import { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import InputDateUTC from '../../../../FormControl/input/InputDateUTC';
import useFetchData from '../../../../../hooks/useFetchData';
import { useDispatch, useSelector } from 'react-redux';
import { updateFilter, showFilter } from '../../../../../store/actions/filter.actions';
import { useLocation, useNavigate } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import InputField from '../../../../FormControl/input/InputField';
import { FormControlLabel, Radio } from '@mui/material';
import SelectMultipleField from '../../../../FormControl/input/SelectMultipleField';
import { updateSkip } from '../../../../../store/actions/datatable.actions';
import DialogConfirmCancel from '../../../../dialog/DialogConfirm';

const FilterDialog = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const date = useSelector((state) => state?.date?.date || new Date());
  const filter = useSelector((state) => state?.filter.user?.filter || {});
  const open = useSelector((state) => state?.filter.user?.open || false);

  const { isLoading: isLoadingRoles, data: dataRoles, error: errorFetchRoles } = useFetchData('roles');
  const { isLoading: isLoadingYears, data: dataYears, error: errorFetchYears } = useFetchData('setting/year');
  const {
    isLoading: isLoadingFlags,
    data: dataFlags,
    error: errorFetchFlags
  } = useFetchData('setting/flags');

  const dispatch = useDispatch();

  const [form, setInputForm] = useState(filter);
  const [error, setInputError] = useState({});

  useEffect(() => {
    if (!isEmpty(filter)) {
      setInputForm(filter);
    }
  }, [filter]);

  const onClose = () => {
    dispatch(showFilter('user', false));
  };

  const onChange = (name, value) => {
    if (name === 'rolesId') {
      setInputError({ ...error, [name]: null, roles: null });
      const roles = dataRoles.filter((item) => value.includes(item.id));
      setInputForm({ ...form, [name]: value, roles });
    } else if (name === 'yearLevelId') {
      setInputError({ ...error, [name]: null, yearLevel: null });
      const yearLevel = dataYears.filter((item) => value.includes(item._id));
      setInputForm({ ...form, [name]: value, yearLevel });
    } else if (name === 'flagId') {
      setInputError({ ...error, [name]: null, flag: null });
      const flag = dataFlags.filter((item) => value.includes(item._id));
      setInputForm({ ...form, [name]: value, flag });
    } else {
      setInputForm({ ...form, [name]: value });
      setInputError({ ...error, [name]: null });
    }
  };

  const onApply = () => {
    onClose();
    const filter = {
      ...form
    };

    dispatch(updateFilter('user', filter));
    dispatch(updateSkip('user', 0));
    navigate(pathname, { state: filter });
  };

  return (
    <DialogConfirmCancel
      id='user-filter'
      open={open}
      title='Filter'
      maxWidth='xs'
      onCancel={onClose}
      onConfirm={onApply}
      textConfirm='Apply'
    >
      <Box className='flex flex-col gap-4'>
        <div className='grid grid-cols-3 items-center gap-4'>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Code
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-code'
              name='code'
              value={form.code}
              error={error.code}
              helperText={error.code}
              maxDate={date}
              onChange={(e) => onChange('code', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            first name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-first-name'
              name='firstName'
              value={form.firstName}
              error={error.firstName}
              helperText={error.firstName}
              maxDate={date}
              onChange={(e) => onChange('firstName', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            last name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-last-name'
              name='lastName'
              value={form.lastName}
              error={error.lastName}
              helperText={error.lastName}
              maxDate={date}
              onChange={(e) => onChange('lastName', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            preferred name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-preferred-name'
              name='preferredName'
              value={form.preferredName}
              error={error.preferredName}
              helperText={error.preferredName}
              onChange={(e) => onChange('preferredName', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Roles
          </Typography>
          <div className='col-span-2'>
            <SelectMultipleField
              id='form-filter-roles'
              name='rolesId'
              value={form.rolesId}
              error={error.rolesId || errorFetchRoles}
              helperText={error.rolesId || errorFetchRoles}
              onChange={(e) => onChange('rolesId', e.target.value)}
              loading={isLoadingRoles}
              options={dataRoles?.map((item) => ({ value: item.id, label: item.name })) || []}
              placeholder='Choose a role'
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            email
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-email'
              name='email'
              value={form.email}
              error={error.email}
              helperText={error.email}
              onChange={(e) => onChange('email', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            year level
          </Typography>
          <div className='col-span-2'>
            <SelectMultipleField
              id='form-filter-year-level'
              name='yearLevelId'
              value={form.yearLevelId}
              error={error.yearLevelId || errorFetchYears}
              helperText={error.yearLevelId || errorFetchYears}
              onChange={(e) => onChange('yearLevelId', e.target.value)}
              loading={isLoadingYears}
              options={dataYears?.map((item) => ({ value: item._id, label: item.name })) || []}
              placeholder='Choose a year level'
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            activated
          </Typography>
          <div className='col-span-2 grid grid-cols-2 gap-2'>
            <FormControlLabel
              control={
                <Radio
                  checked={form.activated === true}
                  name='activated'
                  value={true}
                  onChange={() => onChange('activated', true)}
                  color='primary'
                />
              }
              label='Yes'
            />
            <FormControlLabel
              control={
                <Radio
                  checked={form.activated === false}
                  name='activated'
                  value={false}
                  onChange={() => onChange('activated', false)}
                  color='primary'
                />
              }
              label='No'
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            invited
          </Typography>
          <div className='col-span-2 grid grid-cols-2 gap-2'>
            <FormControlLabel
              control={
                <Radio
                  checked={form.invited === true}
                  name='invited'
                  value={true}
                  onChange={() => onChange('invited', true)}
                  color='primary'
                />
              }
              label='Yes'
            />
            <FormControlLabel
              control={
                <Radio
                  checked={form.invited === false}
                  name='invited'
                  value={false}
                  onChange={() => onChange('invited', false)}
                  color='primary'
                />
              }
              label='No'
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Last login
          </Typography>
          <div className='col-span-2'>
            <InputDateUTC
              id='form-filter-last-login'
              name='lastLogin'
              value={form.lastLogin}
              error={error.lastLogin}
              helperText={error.lastLogin}
              maxDate={date}
              onChange={(value) => onChange('lastLogin', value)}
            />
          </div>

          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Flag
          </Typography>
          <div className='col-span-2'>
            <SelectMultipleField
              id='form-filter-flagId'
              name='flagId'
              value={form.flagId}
              error={error.flagId || errorFetchFlags}
              helperText={error.flagId || errorFetchFlags}
              onChange={(e) => onChange('flagId', e.target.value)}
              loading={isLoadingFlags}
              options={dataFlags?.map((item) => ({ value: item?._id, label: item?.name })) || []}
              placeholder='Choose a flag'
            />
          </div>
        </div>
      </Box>
    </DialogConfirmCancel>
  );
};

export default FilterDialog;
